import { UnavailableIcon } from 'BreetAssets';
import type { JSX, ReactNode } from 'react';

import EmptyState from '../EmptyState/EmptyState';
import Loader from '../Loader/Loader';

interface IQueryBoundary {
	isLoading: boolean;
	isError: boolean;
	onRetry: () => void;
	children: ReactNode;
	hasData?: boolean;
	title?: string;
	description?: string;
	icon?: JSX.Element;
	loadingFallback?: ReactNode;
}

const QueryBoundary = ({
	isLoading,
	isError,
	onRetry,
	children,
	hasData,
	title,
	description,
	icon,
	loadingFallback,
}: IQueryBoundary) => {
	if (isLoading && !hasData) return <>{loadingFallback ?? <Loader />}</>;

	if (isError && !hasData) {
		return (
			<EmptyState
				icon={icon ?? <UnavailableIcon />}
				title={title ?? "We couldn't load this"}
				description={description ?? 'Something went wrong on our end. Please try again.'}
				actionLabel='Retry'
				onAction={onRetry}
			/>
		);
	}

	return <>{children}</>;
};

export default QueryBoundary;
